import React from 'react';
import styled from 'astroturf/react';

import AvatarBase from 'js/social/shared/Avatar';
import { User } from 'js/social/UserCard';
import { Chain } from 'js/social/Comment/types';
import _Container from "Base-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Base.tsx?styleId=Container";
import _BodyContainer from "Base-BodyContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Base.tsx?styleId=BodyContainer";
import _Avatar from "Base-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Base.tsx?styleId=Avatar";
import _Content from "Base-Content.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Base.tsx?styleId=Content";


const PLACEHOLDER_PHOTO = '//a.academia-assets.com/images/s65_no_pic.png';

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const BodyContainer = /*#__PURE__*/styled("div", null, {
  displayName: "BodyContainer",
  styles: _BodyContainer
});

const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});

const Content = /*#__PURE__*/styled("div", null, {
  displayName: "Content",
  styles: _Content
});

interface Props {
  className?: string;
  commenter: User;
  commenterUrl?: string;
  chain?: Chain;
  header: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
}

const Base: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  commenter,
  commenterUrl,
  chain,
  header,
  content,
  footer,
  children,
}) => (
  <Container className={className}>
    <Avatar
      fullName={commenter.displayName}
      photoUrl={commenter.photo || PLACEHOLDER_PHOTO}
      profileUrl={commenterUrl}
    />
    <Content>
      <BodyContainer
        expanded={chain === 'expanded'}
        collapsed={chain === 'collapsed'}
        reply={chain === 'reply'}
        more={chain === 'more'}
      >
        {header}
        {content}
        {footer}
      </BodyContainer>

      {children}
    </Content>
  </Container>
);

export default Base;
